import CoverLink from "components/Cover/CoverLink";
import { LetterbooksConditionType, LetterbookType } from "features/Letterbooks/types";

export default function LetterbookShelfRow({
  letterbook,
  settings,
}: {
  letterbook: LetterbookType;
  settings: LetterbooksConditionType;
}) {
  return (
    <div className="flex flex-row">
      <CoverLink size="md" book={letterbook.book} edition={letterbook.edition} settings={{ referrerId: settings.referrer_id, showStatus: true }} />
    </div>
  );
}
